
import React from 'react';

import {
    Modal, ModalHeader, ModalBody, ModalFooter,
    Button,
    Container,
    Row,
    Col
} from 'reactstrap';

import RGL, { WidthProvider } from "react-grid-layout";
import 'react-grid-layout/css/styles.css'
import 'react-resizable/css/styles.css'

import Isvg from 'react-inlinesvg';
import moveIcon from '../../assets/svg/move.svg';
import moreIcon from '../../assets/svg/more.svg';
import holidayIcon from '../../assets/svg/holiday.svg';


import moment from 'moment';
import DateNavigation from './dateNavigation';
import CalendarEventComponent from './calendarEventComponent';
import CustomCalendar from './customCalendar';
import CustomFilterCalendar from './customFilterCalendar';
import Page from '../../containers/page';
import { API_ENDPOINT } from '../../constants';
import { Player, Controls } from "@lottiefiles/react-lottie-player";
import { v4 as uuidv4 } from 'uuid';
import UpdateEventModal from './updateEventModal';
import ErrorModal from '../../components/errorModal';
import ScheduleEventModal from './scheduleEventModal';
import ScheduleSlot from './scheduleEventHelper/scheduleSlot';
import OccupancyDateNavigation from './occupancyDateNavigation';
import { convertSvDateToEn, generateDateString } from './helper';

import { Tooltip } from '@material-ui/core';
import { withStyles, makeStyles } from "@material-ui/core/styles";


const LightTooltipHoliday = withStyles((theme) => ({
    tooltip: {
        backgroundColor: "#e61f00",
        color: "#fff",
        boxShadow: theme.shadows[1],
        fontSize: 14
    }
}))(Tooltip);

function parseJSON(response) {
    return response.json().then(json => {
        return {
            result: json,
            status: response.status
        }
    })
}


class OccupancyCalendar extends React.Component {

    constructor(props) {
        super(props);
        this.calendarWrapRef = React.createRef();
        this.state = {
            viewMode: 'duration',
            date: this.props?.getStringDateTs ? this.props.getStringDateTs(Math.floor(new Date().getTime() / 1000), 'MM/DD/YYYY') : moment.unix(Math.floor(new Date().getTime() / 1000)).format('MM/DD/YYYY'),
            view: 'month',
            weekDays: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
        }
    }

    setInitialData = () => {
        this.fetchCalendar();

        if (this.props.onChangeDate)
            this.props.onChangeDate(this.state.date, this.state.view, this.state.viewMode);
    }

    googleHolidayEvents = () => {
        fetch(API_ENDPOINT + '/google/holidays/events/' + this.props.selectedGroup, {
            method: 'GET',
            headers: {
                'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                'content-type': 'application/json'
            },
        }).then(res => res.json()).then((result) => {
            if (result.error) {
                this.setState({
                    error: result.error.translate(this.props.lang)
                })
            } else {

                if (this.state.holidayEvents && this.state.holidayEvents.length && result.items && result.items.length) {
                    let holidayEvents = [...this.state.holidayEvents, ...result.items]
                    for (let i = 0; i < holidayEvents.length; i++) {
                        if (holidayEvents[i].date) {
                            let _start = `${holidayEvents[i].date} 08:00`;
                            let _end = `${holidayEvents[i].date} 17:00`;
                            holidayEvents[i].startTime = Math.floor(new Date(_start).getTime() / 1000);
                            holidayEvents[i].endTime = Math.floor(new Date(_end).getTime() / 1000);
                        }
                    }
                    holidayEvents = holidayEvents.map(item => {
                        return {
                            ...item,
                            _date: convertSvDateToEn(item.date)
                        }
                    });

                    this.setState({ holidayEvents })
                } else if (result.items && result.items.length) {
                    let holidayEvents = [...result.items]
                    for (let i = 0; i < holidayEvents.length; i++) {
                        if (holidayEvents[i].date) {
                            let _start = `${holidayEvents[i].date} 08:00`;
                            let _end = `${holidayEvents[i].date} 17:00`;
                            holidayEvents[i].startTime = Math.floor(new Date(_start).getTime() / 1000);
                            holidayEvents[i].endTime = Math.floor(new Date(_end).getTime() / 1000);
                        }
                    }

                    holidayEvents = holidayEvents.map(item => {
                        return {
                            ...item,
                            _date: convertSvDateToEn(item.date)
                        }
                    });

                    this.setState({ holidayEvents })
                }

            }
        })
    }
    checkIfAnyHolidayEventExists = (days) => {
        if (!days?.length) return false;
        const holidayEvents = this.state.holidayEvents ?? [];

        let check = false;
        for (let i = 0; i < days?.length; i++) {
            let item = days[i];
            const holidays = holidayEvents?.filter(el => el?._date === item?.dateString);
            if (holidays?.length) {
                check = true;
                break;
            }
        }
        return check;
    }



    componentDidMount() {
        this.setInitialData();

        this.googleHolidayEvents();

    }
    componentDidUpdate(prevProps, prevState) {
        const dateChanged = prevState?.date !== this.state?.date;
        const viewChanged = prevState?.view !== this.state?.view;
        const viewModeChanged = prevState?.viewMode !== this.state?.viewMode;
        if (dateChanged || viewChanged /*|| viewModeChanged*/) {
            if (dateChanged || viewChanged) {
                this.fetchCalendar();
            }
            if (this.props.onChangeDate)
                this.props.onChangeDate(this.state.date, this.state.view, this.state.viewMode);
        }

    }
    componentWillUnmount() {


    }
    changeView = (view) => {
        let possibleViews = ['week', 'month', 'day', 'work-week'];
        if (!possibleViews.includes(view)) return;
        if (view === this.state.view) return;
        this.setState({
            view
        })
    }
    changeViewMode = (viewMode) => {
        let possibleViewModes = ['duration', 'counts'];
        if (!possibleViewModes.includes(viewMode)) return;
        if (viewMode === this.state.viewMode) return;
        this.setState({
            viewMode
        })
    }

    fetchCalendar = () => {

        let data = {
            date: this.state.date,
            view: this.state.view,
        }
        if (!data.date || !data.view) return;


        this.setState({ calendar: [], loading: true }, () => {
            let fetchKey = uuidv4();
            this.fetchKey = fetchKey;
            data.fetchKey = fetchKey;
            fetch(API_ENDPOINT + `/data/calendar/occupancy/fetch-calendar`, {
                method: 'POST',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                },
                body: JSON.stringify(data)
            }).then(parseJSON).then(({ result, status }) => {
                if (result?.calendar && this.fetchKey === result?.fetchKey) {
                    this.setState({ calendar: result.calendar, loading: false })
                } else {
                    this.setState({ loading: false })
                }
            }).catch(err => {
                console.log(err);
                this.setState({ loading: false })
            })
        })

    }


    getGroupData = () => {
        let selectedGroupIdx = -1;
        if (this.props.uData && this.props.selectedGroup && this.props.uData?.clinicGroups?.length) {
            for (let i = 0; i < this.props.uData.clinicGroups.length; i++) {
                if (this.props.uData.clinicGroups[i]._id == this.props.selectedGroup) {
                    selectedGroupIdx = i;
                    break;
                }
            }
        }
        const groupData = this.props.uData?.clinicGroups?.[selectedGroupIdx];

        return groupData;
    }


    render() {
        if (typeof window === 'undefined') {
            return;
        }

        const customFilters = this.props.customFilters?.length ? this.props.customFilters : [];
        const viewMode = this.state.viewMode;
        const calendar = this.state.calendar || [];
        const view = this.state.view || 'month';

        const legendData = this.props.legendData?.length ? this.props.legendData : [];

        const data = this.props.data || {};

        const summary = this.props.summary || null;
        const summaryTitle = generateDateString(this.state.date, this.state.view, this.props.lang, this.props.getStringDateTs);

        const _totalColor = '#E6951F';
        const _bookedTimeColor = '#E05555';
        const _availableTimeColor = '#3FB3AD';
        const _countOfEventsColor = '#3FB3AD';

        const groupData = this.getGroupData();
        const clinicData = groupData?.clinics?.find(item => item._id === this.props.selectedClinic) || null;
        const departmentName = `${clinicData?.name} ${clinicData?.subgroupName}`;

        const holidayEvents = this.state?.holidayEvents || [];
        const anyHolidayExists = this.checkIfAnyHolidayEventExists(calendar);

        return (
            <div className='custom-calendar-component-wrap'>
                <div className='custom-calendar-navigation-wrap'>
                    <div className='custom-filters-navigation-wrap' >
                        {customFilters?.length ? customFilters : null}
                    </div>
                    <div className='custom-calendar-view-navigation'>
                        <Button
                            color='primary'
                            onClick={() => this.changeViewMode('duration')}
                            className={viewMode !== 'duration' ? 'inactive-view-btn' : ''}
                        >
                            {'Duration'.translate(this.props.lang)}
                        </Button>
                        <Button
                            color='primary'
                            onClick={() => this.changeViewMode('counts')}
                            className={viewMode !== 'counts' ? 'inactive-view-btn' : ''}
                        >
                            {'Counts'.translate(this.props.lang)}
                        </Button>
                    </div>
                    <div className='custom-calendar-view-navigation'>
                        <Button
                            color='primary'
                            onClick={() => this.changeView('day')}
                        >
                            {'Day'.translate(this.props.lang)}
                        </Button>
                        <Button
                            color='primary'
                            onClick={() => this.changeView('work-week')}
                        >
                            {'Work week'.translate(this.props.lang)}
                        </Button>
                        <Button
                            color='primary'
                            onClick={() => this.changeView('week')}
                        >
                            {'Week'.translate(this.props.lang)}
                        </Button>
                        <Button
                            color='primary'
                            onClick={() => this.changeView('month')}
                        >
                            {'Month'.translate(this.props.lang)}
                        </Button>
                    </div>
                    <div>
                        <OccupancyDateNavigation
                            {...this.props}
                            view={this.state.view}
                            date={this.state.date}
                            onChange={(date) => {
                                this.setState({ date })
                            }}
                        />

                    </div>
                </div>
                <div className='occupancy-calendar-content-wrap'>
                    {
                        summary ?
                            <div className='occupancy-summary-wrap' style={this.calendarWrapRef?.current?.offsetHeight > 350 ? { height: this.calendarWrapRef.current.offsetHeight } : {}}>
                                {
                                    departmentName?.trim() ?
                                        <div className='occupancy-summary-item'>
                                            <h6>{departmentName}</h6>
                                        </div>
                                        :
                                        null
                                }
                                <div className='occupancy-summary-item'>
                                    <h6>{'Summary'.translate(this.props.lang)}</h6>
                                    <p>{summaryTitle}</p>
                                </div>
                                {
                                    viewMode === 'duration' ?
                                        <>
                                            <div className='occupancy-summary-item'>
                                                <h6>
                                                    <div style={{ backgroundColor: _totalColor, width: 16, height: 16 }}></div>
                                                    {'Total'.translate(this.props.lang)}
                                                </h6>
                                                <p>{summary.totalString}</p>
                                            </div>
                                            <div className='occupancy-summary-item'>
                                                <h6>
                                                    <div style={{ backgroundColor: _availableTimeColor, width: 16, height: 16 }}></div>
                                                    {'Available'.translate(this.props.lang)}
                                                </h6>
                                                <p>{summary.availableTimeString} <span>({summary?.availableTimePercentage})</span></p>
                                            </div>
                                            <div className='occupancy-summary-item'>
                                                <h6>
                                                    <div style={{ backgroundColor: _bookedTimeColor, width: 16, height: 16 }}></div>
                                                    {'Booked'.translate(this.props.lang)}
                                                </h6>
                                                <p>{summary.bookedTimeString} <span>({summary?.bookedTimePercentage})</span></p>
                                            </div>
                                        </>
                                        :
                                        viewMode === 'counts' ?
                                            <>
                                                <div className='occupancy-summary-item'>
                                                    <h6>
                                                        <div style={{ backgroundColor: _countOfEventsColor, width: 16, height: 16 }}></div>
                                                        {'Events'.translate(this.props.lang)}
                                                    </h6>
                                                    <p>{summary.countOfEvents}</p>
                                                </div>
                                            </>
                                            :
                                            null
                                }
                            </div>
                            :
                            null
                    }
                    <div className='calendar-content-wrap' ref={this.calendarWrapRef} style={['week', 'day', 'work-week']?.indexOf(view) !== -1 ? { minWidth: 'unset' } : {}}>
                        {
                            view === 'month' ?
                                <>
                                    {
                                        this.state.weekDays?.map((item, idx) => {
                                            return (
                                                <div className='calendar-week-day-item'>
                                                    <h6>{item?.translate(this.props.lang)}</h6>
                                                </div>
                                            )
                                        })
                                    }
                                    {
                                        calendar.map((item, idx) => {
                                            let className = 'calendar-month-item';
                                            if (item.today) className += ' today-item';
                                            if (item?.notThisMonth) className += ' not-this-month-item';

                                            const weekNumber = item?.dayString === 'Monday' && item?.weekNumber ? `${'v.'.translate(this.props.lang)}${item.weekNumber}` : null;

                                            const availabilityData = data?.[item?.dateString] || null;
                                            const bookedTime = availabilityData?.bookedTimeString ?? null;
                                            const bookedTimePercentage = availabilityData?.bookedTimePercentage ?? null;
                                            const availableTime = availabilityData?.availableTimeString ?? null;
                                            const availableTimePercentage = availabilityData?.availableTimePercentage ?? null
                                            const total = availabilityData?.totalString ?? null;
                                            const countOfEvents = availabilityData?.countOfEvents ?? 0;

                                            const holidays = holidayEvents?.filter(el => el?._date === item?.dateString);


                                            return (
                                                <div
                                                    className={className}
                                                    onClick={() => {

                                                    }}
                                                >
                                                    <div className='calendar-month-item-content-upper'>
                                                        <div className='calendar-month-item-content-upper-left'>
                                                            {weekNumber ?
                                                                <h6
                                                                    className='week-number'
                                                                    onClick={() => {
                                                                        if (!item?.dateString) return;
                                                                        this.setState({ date: item?.dateString }, () => {
                                                                            this.changeView('week');
                                                                            if (this.props.onChangeDate)
                                                                                this.props.onChangeDate(this.state.date, 'week', this.state.viewMode);
                                                                        })

                                                                    }}
                                                                >
                                                                    {weekNumber}
                                                                </h6>
                                                                :
                                                                null
                                                            }
                                                        </div>
                                                        <div className='calendar-month-item-content-upper-right'>
                                                            {
                                                                holidays?.length ?
                                                                    <LightTooltipHoliday
                                                                        title={holidays.map((el, index) => {
                                                                            return <>
                                                                                <div key={index} style={{ marginBottom: '2px' }}>{this.props.lang === 'en' && el.titleEn ? el.titleEn.trim() : el.title.trim()}</div>
                                                                            </>
                                                                        })}
                                                                        placement="top-start"
                                                                    >
                                                                        <div className='holiday-events-month-view-wrap'  >
                                                                            <div className='holiday-events-month-view-icon-wrap'>
                                                                                <div className='svg-wrap' style={{ top: 0, cursor: 'default' }}>
                                                                                    <Isvg src={holidayIcon} />
                                                                                </div>

                                                                            </div>


                                                                        </div>
                                                                    </LightTooltipHoliday>
                                                                    :
                                                                    null
                                                            }
                                                            <h6
                                                                style={{ cursor: 'pointer' }}
                                                                className={item.today ? 'today-date' : ''}
                                                                onClick={() => {
                                                                    if (!item?.dateString) return;
                                                                    this.setState({ date: item?.dateString }, () => {
                                                                        this.changeView('day');
                                                                        if (this.props.onChangeDate)
                                                                            this.props.onChangeDate(this.state.date, 'day', this.state.viewMode);
                                                                    })

                                                                }}
                                                            >
                                                                {item.day}
                                                            </h6>
                                                        </div>
                                                    </div>
                                                    <div className='calendar-month-item-content-lower'>
                                                        {
                                                            viewMode === 'duration' ?
                                                                <div className='calendar-month-item-content-lower-duration'>
                                                                    {
                                                                        bookedTime ?
                                                                            <div className={`calendar-month-item-content-lower-duration-item booked-time-color ${item?.notThisMonth ? 'not-this-month-color' : ''}`}>
                                                                                <p>{bookedTime}</p>
                                                                                <p>{bookedTimePercentage}</p>
                                                                            </div>
                                                                            : null
                                                                    }
                                                                    {
                                                                        availableTime ?
                                                                            <div className={`calendar-month-item-content-lower-duration-item available-time-color ${item?.notThisMonth ? 'not-this-month-color' : ''}`}>
                                                                                <p>{availableTime}</p>
                                                                                <p>{availableTimePercentage}</p>
                                                                            </div>
                                                                            : null
                                                                    }
                                                                    {
                                                                        total ?
                                                                            <div className={`calendar-month-item-content-lower-duration-item total-color ${item?.notThisMonth ? 'not-this-month-color' : ''}`}>
                                                                                <p>{total}</p>
                                                                            </div>
                                                                            : null
                                                                    }
                                                                </div>
                                                                :
                                                                null
                                                        }
                                                        {
                                                            viewMode === 'counts' && availabilityData ?
                                                                <div className='calendar-month-item-content-lower-duration'>
                                                                    <div className={`calendar-month-item-content-lower-duration-item count-of-events ${item?.notThisMonth ? 'not-this-month-color' : ''}`}>
                                                                        <p>{countOfEvents}</p>
                                                                    </div>
                                                                </div>
                                                                :
                                                                null
                                                        }
                                                    </div>

                                                </div>
                                            )
                                        })
                                    }
                                </>
                                :
                                null
                        }
                        {
                            ['week', 'day', 'work-week']?.indexOf(view) !== -1 ?
                                <>
                                    {
                                        calendar?.map((item, idx) => {
                                            let className = 'calendar-week-item';
                                            // if (item.today) className += ' today-item';

                                            const weekNumber = item?.dayString === 'Monday' && item?.weekNumber ? `${'v.'.translate(this.props.lang)}${item.weekNumber}` : null;
                                            const dayTitle = `${item?.day} ${item?.dayString?.translate(this.props.lang)}`;

                                            const availabilityData = data?.[item?.dateString] || null;
                                            const bookedTime = availabilityData?.bookedTimeString ?? null;
                                            const bookedTimePercentage = availabilityData?.bookedTimePercentage ?? null;
                                            const availableTime = availabilityData?.availableTimeString ?? null;
                                            const availableTimePercentage = availabilityData?.availableTimePercentage ?? null
                                            const total = availabilityData?.totalString ?? null;
                                            const countOfEvents = availabilityData?.countOfEvents ?? 0;

                                            const holidays = holidayEvents?.filter(el => el?._date === item?.dateString);
                                            return (
                                                <div
                                                    className={className}
                                                    onClick={() => {

                                                    }}
                                                    style={{ width: view === 'week' ? '13%' : view === 'day' ? '100%' : '20%' }}
                                                >
                                                    <div className='calendar-week-item-content-upper'>
                                                        <h6 className={item?.today ? 'today-date' : ''}>{dayTitle}</h6>
                                                    </div>
                                                    {/* <div className='calendar-week-item-content-lower'>

                                                    </div> */}
                                                    {
                                                        holidays?.length ?
                                                            holidays.map((el, index) => {
                                                                return (
                                                                    <div className='custom-calendar-header-dates-item-date-holiday' style={{ marginBottom: 5 }}>
                                                                        <LightTooltipHoliday title={this.props.lang === 'en' && el.titleEn ? el.titleEn.trim() : el.title.trim()} placement="top-start" >
                                                                            <div key={index} className="rbc-event-label " style={{ display: 'flex', width: '100%', backgroundColor: '#e7e7e7', borderTopRightRadius: '5px', borderTopRightRadius: '5px', borderBottomRightRadius: '5px', color: '#000', }}>
                                                                                <div style={{ backgroundColor: '#e61f00', height: 16, minWidth: 8 }}></div>
                                                                                <div style={{ paddingLeft: 5, paddingRight: 5, maxWidth: 200, fontSize: '12px', textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>{this.props.lang === 'en' && el.titleEn ? el.titleEn.trim() : el.title.trim()}</div>
                                                                            </div>
                                                                        </LightTooltipHoliday>
                                                                    </div>
                                                                )

                                                            })
                                                            :
                                                            anyHolidayExists ?
                                                                <div style={{ height: 23 }}></div>
                                                                :
                                                                null

                                                    }

                                                    <div className='calendar-week-item-content-items-wrap' style={item.today ? { backgroundColor: '#eaf6ff' } : {}}>
                                                        {
                                                            viewMode === 'duration' ?
                                                                <div className='calendar-week-item-content-lower-duration'>
                                                                    {
                                                                        bookedTime ?
                                                                            <div className={`calendar-week-item-content-lower-duration-item booked-time-color `}>
                                                                                <p>{bookedTime}</p>
                                                                                <p>{bookedTimePercentage}</p>
                                                                            </div>
                                                                            : null
                                                                    }
                                                                    {
                                                                        availableTime ?
                                                                            <div className={`calendar-week-item-content-lower-duration-item available-time-color `}>
                                                                                <p>{availableTime}</p>
                                                                                <p>{availableTimePercentage}</p>
                                                                            </div>
                                                                            : null
                                                                    }
                                                                    {
                                                                        total ?
                                                                            <div className={`calendar-week-item-content-lower-duration-item total-color `}>
                                                                                <p>{total}</p>
                                                                            </div>
                                                                            : null
                                                                    }
                                                                </div>
                                                                :
                                                                null
                                                        }
                                                        {
                                                            viewMode === 'counts' && availabilityData ?
                                                                <div className='calendar-week-item-content-lower-duration'>
                                                                    <div className={`calendar-week-item-content-lower-duration-item count-of-events `}>
                                                                        <p>{countOfEvents}</p>
                                                                    </div>
                                                                </div>
                                                                :
                                                                null
                                                        }

                                                    </div>

                                                </div>
                                            )
                                        })
                                    }
                                </>
                                :
                                null
                        }

                    </div>
                </div>

                {/* <div className='custom-calendar-footer-wrap'>
                    <div className='custom-calendar-footer-legend-wrap'>
                        {
                            legendData?.filter(item => item.viewMode === viewMode)?.map((item, idx) => {
                                return (
                                    <div key={idx} className='custom-calendar-footer-legend-item-wrap'>
                                        <div className='custom-calendar-footer-legend-item-color' style={{ backgroundColor: item.color }}></div>
                                        <div className='custom-calendar-footer-legend-item-text'>{item.name}</div>
                                    </div>
                                )
                            })
                        }
                    </div>
                    <div className='custom-calendar-footer-zoom-options-wrap'>

                    </div>
                </div> */}

            </div>


        )
    }
}

export default OccupancyCalendar;